export default __webpack_public_path__ + "static/semantic-0a4d7cec7bdc80203ee8667b8a4c2a35.png";